import type { Ref } from '@vue/composition-api';
import { onBeforeUnmount, computed, ref, watch } from '@vue/composition-api';

export const useDeferredLoading = (loading: Ref<boolean>, minimumLoadingTime = 500) => {
  const deferredLoadingTimer = ref(null);
  const elapsedLoadingTime = ref(0);

  const startDeferredLoadingTimer = () => {
    resetDeferredLoadingTimer();
    deferredLoadingTimer.value = setInterval(() => {
      elapsedLoadingTime.value += 100;
    }, 100);
  };

  const endDeferredLoadingTimer = () => {
    setTimeout(() => {
      resetDeferredLoadingTimer();
    }, Math.max(0, minimumLoadingTime - elapsedLoadingTime.value));
  };

  const resetDeferredLoadingTimer = () => {
    clearInterval(deferredLoadingTimer.value);
    deferredLoadingTimer.value = null;
    elapsedLoadingTime.value = 0;
  };

  watch(loading, () => {
    if (loading.value) {
      startDeferredLoadingTimer();
      return;
    }
    endDeferredLoadingTimer();
  });

  onBeforeUnmount(() => {
    resetDeferredLoadingTimer();
  });

  return computed(() => deferredLoadingTimer.value !== null);
};
